// extracted by mini-css-extract-plugin
export default {"logo":"LogoG20-module__[local]___f2MhC","invert":"LogoG20-module__[local]___Xjzb5","text":"LogoG20-module__[local]___ohlCM"};